import _ from '@luna/lodash';

import {
    getFeatureConfigSingleton,
    getFeatureConfigWithoutOverrides,
} from './featureConfigSingleton';

const URL_CONFIG_PARAM = 'config';
const DEFAULT_STORAGE_CONFIG_PARAM = 'featureConfig';

export function parseFeatureConfigFromUrl(): unknown {
    return JSON.parse(new URLSearchParams(window.location.search).get(URL_CONFIG_PARAM) ?? '{}');
}

function getStorageKey(): string {
    return process.env.FEATURE_CONFIG_STORAGE_KEY || DEFAULT_STORAGE_CONFIG_PARAM;
}

export function parseFeatureConfigFromStorage(): unknown {
    return JSON.parse(localStorage.getItem(getStorageKey()) || '{}');
}
export function saveFeatureConfigToStorage(config: unknown): void {
    localStorage.setItem(getStorageKey(), JSON.stringify(config));
}

export function isFeatureConfigOverriden(): boolean {
    return !_.isEqual(getFeatureConfigWithoutOverrides(), getFeatureConfigSingleton());
}
